import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from '@chakra-ui/react';
import {
  AppCard,
  OutlineButton,
  PrimaryButton,
  SortableTh,
  StatusBadge,
} from '../../../components/ui';
import { useTableSort } from '../../../hooks/useTableSort';

/** Shared shell for Master Data list pages (UI-only / mock). */
export function MasterDataPage({
  title,
  description,
  columns,
  rows,
  addLabel = 'Add',
}) {
  const { sorted, sort, toggleSort } = useTableSort(rows);

  return (
    <Box>
      <Flex
        justify="space-between"
        align={{ base: 'start', md: 'center' }}
        gap={4}
        mb={6}
        wrap="wrap"
      >
        <Box>
          <Heading size="lg">{title}</Heading>
          {description ? (
            <Text color="text.secondary" mt={2} maxW="640px">
              {description}
            </Text>
          ) : null}
        </Box>
        <Flex gap={2}>
          <OutlineButton size="sm">Export</OutlineButton>
          <PrimaryButton size="sm">{addLabel}</PrimaryButton>
        </Flex>
      </Flex>

      <AppCard p={0} overflow="hidden">
        <Box overflowX="auto">
          <Table variant="simple" size="md">
            <Thead bg="bg.input">
              <Tr>
                {columns.map((col) => (
                  <SortableTh
                    key={col.key}
                    columnKey={col.key}
                    sort={sort}
                    onSort={toggleSort}
                  >
                    {col.label}
                  </SortableTh>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {sorted.map((row) => (
                <Tr key={row.id}>
                  {columns.map((col) => (
                    <Td key={col.key} fontWeight={col.key === 'name' ? '600' : '400'}>
                      {col.render ? col.render(row) : row[col.key]}
                    </Td>
                  ))}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </AppCard>
    </Box>
  );
}

export function ActiveBadge({ active }) {
  return (
    <StatusBadge status={active ? 'verified' : 'neutral'}>
      {active ? 'Active' : 'Inactive'}
    </StatusBadge>
  );
}
